import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
  requireSuperAdmin?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, requireSuperAdmin = false }) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  console.log('PrivateRoute mounted/updated:', {
    isAuthenticated,
    user,
    requireSuperAdmin,
    currentPath: location.pathname,
    userLevel: user?.level_id,
    isSuperAdmin: user?.level_id === 1
  });

  if (!isAuthenticated) {
    console.log('Not authenticated, redirecting to login...');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 如果需要超级管理员权限，但当前用户不是超级管理员
  if (requireSuperAdmin && user?.level_id !== 1) {
    console.log('Super admin required but user is not super admin:', {
      requireSuperAdmin,
      userLevel: user?.level_id,
      currentPath: location.pathname
    });
    return <Navigate to="/users" replace />;
  }

  console.log('Authentication successful, rendering protected content');
  return <>{children}</>;
};

export default PrivateRoute; 